/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandStatusRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandStatusResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandStatus = (request: SetBrandStatusRequest, options?: CashRequestOptions) => post<SetBrandStatusRequest, SetBrandStatusResponse>("/2.0/cash/set-brand-status", request, {...options, rejectOnError: true })